import {hide} from "@popperjs/core";

let fetchController = null;

function showOverlay() {
    document.getElementById('ticket-search-overlay')?.classList.remove('d-none');
}

function hideOverlay() {
    document.getElementById('ticket-search-overlay')?.classList.add('d-none');
}
export function setupTicketSelector() {
    const form = document.getElementById('ticket-form');
    const findBtn = document.getElementById('find-tickets-btn');
    
    if (findBtn) {
        findBtn.addEventListener('click', () => {
            findBtn.disabled = true;
            window.setTimeout(() => {
                findBtn.disabled = false;
            }, 10000); // re enable after 10 seconds(?)
        });

        findBtn.addEventListener('click', async (e) => {
            e.preventDefault();

            try {
                await submitForm();
                console.log('Form submitted successfully');
                debugger;
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        });
    }
    if (!form) return;

    const MAX_TOTAL_TICKETS = parseInt(form.dataset.maxTotal, 10) || Infinity;
    const MIN_TOTAL_TICKETS = parseInt(form.dataset.minTotal, 10) || 0;
    const TICKET_TYPE_LIMITS = JSON.parse(form.dataset.ticketTypeLimits || '{}'); // { ticketTypeId: { min: x, max: y } }
    const MEMBER_LIMITS = JSON.parse(form.dataset.memberLimits || '{}'); // { min: x, max: y }

    function getTotalTicketsSelected() {
        const counts = {};
        const total = [...form.querySelectorAll('input[type="number"]')].reduce((sum, input) => {
            const type = input.dataset.ticketType;
            const value = parseInt(input.value, 10) || 0;
            counts[type] = (counts[type] || 0) + value;
            return sum + value;
        }, 0);
        return { total, counts };
    }

    function updateAllTicketStates() {
        const { total, counts } = getTotalTicketsSelected();
        const announcer = document.getElementById('quantity-announcer');
        const remainingDisplay = document.getElementById('ticket-remaining');

        form.querySelectorAll('.ticket').forEach(ticket => {
            const input = ticket.querySelector('input[type="number"]');
            const addBtn = ticket.querySelector('.add');
            const subBtn = ticket.querySelector('.subtract');

            const value = parseInt(input.value, 10) || 0;
            const min = parseInt(input.min, 10) || 0;
            const max = parseInt(input.max, 10) || 10;
            const type = input.dataset.ticketType;
            const typeLimits = TICKET_TYPE_LIMITS[type] || {};
            const typeMin = typeLimits.min ?? min;
            const typeMax = typeLimits.max ?? max;

            subBtn.disabled = value <= typeMin;
            addBtn.disabled = value >= typeMax || total >= MAX_TOTAL_TICKETS;

            input.classList.toggle('at-max', value >= typeMax || total >= MAX_TOTAL_TICKETS);
            input.classList.toggle('at-min', value <= typeMin);
        });

        if (announcer) {
            announcer.textContent = `${total} ticket${total !== 1 ? 's' : ''} selected total`;
        }

        if (remainingDisplay) {
            const remaining = MAX_TOTAL_TICKETS - total;
            remainingDisplay.textContent = `${remaining} ticket${remaining !== 1 ? 's' : ''} remaining`;
        }

        if (findBtn) {
            findBtn.disabled = total < MIN_TOTAL_TICKETS;
            findBtn.textContent = total > 0
                ? `Hitta ${total} biljett${total === 1 ? '' : 'er'}`
                : 'Hitta biljetter';
        }
    }

    // Form submit
    async function submitForm() {
        const action = form.getAttribute('action');
        const formData = new FormData(form);
        
        const queryString = new URLSearchParams(formData).toString();

        fetchController = new AbortController();
        showOverlay();

        try {
            const response = await fetch(action, {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: queryString,
                signal: fetchController.signal,
            });
            debugger;
            if (response.ok) {
                debugger;
                const result = await response.json();
                
                const {error, message} = result;
                if (error) {
                    alert(message);
                    hideOverlay();
                    return;
                }
                
                if (result.redirectUrl) {
                    window.location.href = result.redirectUrl;
                } else {
                    form.removeEventListener('onsubmit');
                    form.submit();
                }
            } else {
                console.error('Error during ticket search:', response.statusText);
                debugger;
                throw new Error(response.statusText);
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Ticket search aborted.');
            } else {
                console.error('Error during ticket search:', error);
                form.submit(); // fallback
            }
        } finally {
            // hideOverlay();
            fetchController = null;
        }
    }

    // Event bindings
    form.querySelectorAll('.ticket').forEach(ticket => {
        const input = ticket.querySelector('input[type="number"]');
        const addBtn = ticket.querySelector('.add');
        const subBtn = ticket.querySelector('.subtract');

        const min = parseInt(input.min, 10) || 0;
        const max = parseInt(input.max, 10) || 10;
        const interval = parseInt(ticket.dataset.interval, 10) || 1;

        addBtn?.addEventListener('click', () => {
            let value = parseInt(input.value, 10) || 0;
            input.value = Math.min(value + interval, max);
            updateAllTicketStates();
        });

        subBtn?.addEventListener('click', () => {
            let value = parseInt(input.value, 10) || 0;
            input.value = Math.max(value - interval, min);
            updateAllTicketStates();
        });

        input.addEventListener('input', () => {
            let value = parseInt(input.value, 10) || 0;
            input.value = Math.min(Math.max(value, min), max);
            updateAllTicketStates();
        });
    });

    // Description toggle
    document.querySelectorAll('.description-switch').forEach(button => {
        button.addEventListener('click', () => {
            const targetId = button.getAttribute('aria-controls');
            const target = document.getElementById(targetId);
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', String(!isExpanded));
            target.classList.toggle('d-none', isExpanded);
        });
    });

    // Form validation
    form.addEventListener('submit', e => {
        const { total, counts } = getTotalTicketsSelected();
        
        if (total < MIN_TOTAL_TICKETS || total > MAX_TOTAL_TICKETS) {
            e.preventDefault();
            alert(`Du måste välja minst ${MIN_TOTAL_TICKETS} och max ${MAX_TOTAL_TICKETS} biljetter totalt.`);
            return;
        }

        for (const [type, value] of Object.entries(counts)) {
            const limits = TICKET_TYPE_LIMITS[type] || {};
            const typeMin = limits.min ?? 0;
            const typeMax = limits.max ?? Infinity;

            if (value < typeMin || value > typeMax) {
                e.preventDefault();
                alert(`Biljetttyp ${type} kräver minst ${typeMin} och max ${typeMax} biljetter.`);
                return;
            }
        }

        const memberMin = MEMBER_LIMITS.min ?? 0;
        const memberMax = MEMBER_LIMITS.max ?? Infinity;
        if (total < memberMin || total > memberMax) {
            e.preventDefault();
            alert(`Medlemmar kan välja minst ${memberMin} och max ${memberMax} biljetter.`);
            return;
        }
    });

    updateAllTicketStates();
}